import { $qs, $qsa } from '../utils/querySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
import SplitText from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(SplitText);

function sixthFormLanding() {
    if($qs('body').classList.contains('page-template-sixth-form-landing')){        
        const preloader = $qs('[data-target="sixth-form-landing-preloader"]');     
        var sixthFormPreloader = gsap.timeline( ); 
        var preloaderSix = $qs('[data-target="preloader-six"]');
        var preloaderCircle = $qs('[data-target="preloader-circle"]');
        var preloaderTitle = $qs('[data-target="preloader-title"]');
        var preloaderScale = $qs('[data-target="preloader-scale"]');
        var preloaderGradient = $qs('[data-target="preloader-gradient"]');
        var preloaderArrow = $qs('[data-target="preloader-arrow"]');
        var preloaderImage = $qs('[data-target="banner-image"]');
        var preloaderVideoText = $qs('[data-target="banner-video-text"]');
        var sectionMenu = $qs('[data-target="section-menu"]');

        sixthFormPreloader.to(preloaderCircle, {
            opacity:1,
            duration:0.7
        })
        sixthFormPreloader.to(preloaderSix, {
            opacity: 1,
            duration: 0.1,
        }, "<")
        sixthFormPreloader.from('#six', {
            duration:0.8, 
            drawSVG: "50% 50%"
        },">+=0.5");
        sixthFormPreloader.to(preloaderTitle, {
            opacity: 1,
            duration:0.7
        }, "<+=0.2")
        sixthFormPreloader.to(preloaderScale, {
            scale: 1.5,
            duration: 1.7
        }, ">-=0.4")
        sixthFormPreloader.to(preloaderGradient, {
            height: '150%',
            duration: 1.7
        }, "<")
        sixthFormPreloader.to(preloaderImage, {
            opacity: 0.5,
            x:0,
            duration: 1,            
        }, "<+=0.2")
        sixthFormPreloader.to(preloaderVideoText, {
            opacity: 1,
            duration: 1,
        }, "<")
        sixthFormPreloader.to(preloaderArrow, {
            opacity: 1,
            duration: 0.7,
        }, "<")
        sixthFormPreloader.to(sectionMenu, {
            y: 0,
            duration: 0.7,
        }, "<")

        // Intro
        const intro = $qs('[data-name="intro"]');
        const introText = $qs('.intro', intro);
        const nonIntroText = $qsa('p:not(.intro)', intro);
        const introTextSplit = new SplitText(introText, {
            type: "words,chars",
            wordsClass: 'intro-word',
            charClass: 'intro-char'
        });

        const introHeight = intro.offsetHeight;
        const windowHeight = window.innerHeight;
        const start = introHeight >windowHeight ? "top top" : "center center";
        
        var introTl = gsap.timeline({
            scrollTrigger: {
                trigger: intro,
                start: start, 
                end: () => `+=${window.innerHeight*1.5}`,
                scrub: 1,
                pin: true,
            }
        });

        introTl.from(introTextSplit.chars, {
            opacity: 0,
            duration: 1,
            z: 10,
            yPercent: 30,
            rotate: 4,
            rotateX: 100,
            stagger: 0.05,
            ease: 'power2.inOut',            
        });
        introTl.from(nonIntroText, {
            opacity: 0,
            duration: 1,            
        }, ">")

        // Expanding Teaser
        const expandingTeaser = $qs('[data-name="expanding-teaser"]');
        const expandingTeaserImage = $qs('[data-target="expanding-teaser-image"]');
        const expandingTeaserTitle = $qs('[data-target="expanding-teaser-title"]');
        
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: expandingTeaser,
                start: 'top top', 
                end: () => `+=${window.innerHeight*1.5}`,
                scrub: 1,
                // once: true,
                pin: true,
                onLeave: function(self) {
                    self.scroll(self.start);	// <-- sets position to start of ScrollTrigger
                    self.disable()
                    self.animation.progress(1)
                    ScrollTrigger.refresh();
                }
            }
        });

        tl.to(expandingTeaserImage, {
            scale: 1,
            opacity: 1,
            borderRadius: '50px',
            ease: 'none'
        });

        tl.to(expandingTeaserTitle, {
            opacity: 1,
            duration: 1.5,                                
            ease: 'none',
        })

    }

    // Petals
    var petal = $qsa('.petal');    

    petal.forEach(petal => {
        petal.addEventListener('click', function() {
            const petalId = this.id;
            const targetElement = $qs(`[data-name="${petalId}"]`);
            if (targetElement) {
                const targetUrl = targetElement.dataset.target;
                if (targetUrl) {
                    $.magnificPopup.open({
                        items: {
                            src: `#${targetUrl}`,
                            type: 'inline'
                        },
                        closeMarkup: '<button class="mfp-close button">Back</button>'
                    });
                }
            }
        });
        petal.addEventListener('mouseenter', function() {
            const petalId = this.id;
            const targetElement = $qs(`[data-name="${petalId}"]`);
            targetElement.classList.add('opacity-100');
        });
        petal.addEventListener('mouseleave', function() {
            const petalId = this.id;
            const targetElement = $qs(`[data-name="${petalId}"]`);
            targetElement.classList.remove('opacity-100');
        });
    });

}

export default sixthFormLanding;